const files = require.context('~/api/pages/', false, /.js$/)

export default ({ app }, inject) => {
    const modules = {}

    files.keys().forEach((key) => {
        modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default(app)
    })

    inject('api', modules)
}
